export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return `${views}`;
}

export function formatDate(value: string): string {
  const parts = value.split("-");
  if (parts.length !== 3) return value;
  return `${parts[0]}.${parts[1]}.${parts[2]}`;
}

export function ratingTone(rating: number): string {
  if (rating >= 8.6) return "text-accent-600";
  if (rating >= 8) return "text-primary-700";
  return "text-secondary-700";
}